export const isUUID = (val) =>
  typeof val === 'string' ? val.match(/^[0-9a-f]{32}$/) : false;
